module.exports = __webpack_public_path__ + "static/fonts/Mont-Bold.1e9cca3.eot";